import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, Row, Col, FormGroup, Label, Input, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import { handleAddModifyOperation } from '../../../../Api/ApiMethods';

const FileCloseModal = ({ isOpen, toggle, arbitrationId, refreshArbitrationData }) => {
    const [formData, setFormData] = useState({
        willReapply: 'false',
        fileCloseDescription: '',
        fileCloseComment: '',
        fileCloseDescriptionOther: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Modal açıldığında form verilerini sıfırla
    useEffect(() => {
        if (isOpen) {
            setFormData({
                willReapply: 'false',
                fileCloseDescription: '',
                fileCloseComment: '',
                fileCloseDescriptionOther: ''
            });
        }
    }, [isOpen]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            setFormData(prev => ({ ...prev, [name]: checked }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    // Radio buton handler
    const handleRadioChange = (value) => {
        console.log('Radio changed to:', value);
        setFormData(prev => ({
            ...prev,
            willReapply: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.fileCloseDescription.trim()) {
            toast.error('Dosya kapatma yorumu zorunludur.');
            return;
        }

        if (!formData.fileCloseComment.trim()) {
            toast.error('Ek yorum alanı zorunludur.');
            return;
        }

        if (formData.fileCloseDescription === 'Diğer' && !formData.fileCloseDescriptionOther.trim()) {
            toast.error('Diğer dosya kapatma yorumu zorunludur.');
            return;
        }

        setIsSubmitting(true);

        try {
            // API'ye gönderilecek veriyi hazırla
            const apiData = {
                reapplicationInformation: {
                    arbitration: [arbitrationId],
                    willReapply: formData.willReapply === 'true', // String 'true' → boolean true/false
                    willWriteExpertReport: false, // Her zaman false olacak
                    fileCloseDescription: formData.fileCloseDescription, // Dosya Kapatma Yorumu
                    fileCloseDescriptionOther: formData.fileCloseDescription === 'Diğer' ? formData.fileCloseDescriptionOther : '',
                    comments: formData.fileCloseComment ? [{
                        commentType: "Genel",
                        comment: formData.fileCloseComment // Ek Yorum
                    }] : []
                },
                accidentFileCloseInformation: {
                    fileStatus: "Kapalı", // Statik olarak "Kapalı"
                    fileCloseDescription: formData.fileCloseDescription, // Dosya Kapatma Yorumu
                    fileCloseDescriptionOther: formData.fileCloseDescription === 'Diğer' ? formData.fileCloseDescriptionOther : '',
                    fileCloseComment: formData.fileCloseComment // Ek Yorum
                }
            };

            console.log('FileCloseModal: API Data being sent:', apiData);
            console.log('willReapply value type:', typeof apiData.reapplicationInformation.willReapply);
            console.log('willReapply value:', apiData.reapplicationInformation.willReapply);

            const fileCloseApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/Arbitration/patch-arbitration-close';

            await handleAddModifyOperation({
                apiEndpoint: fileCloseApiUrl,
                selectedItem: { id: arbitrationId },
                mode: 'modify',
                data: apiData,
                httpMethod: 'PUT',
                refreshDataCallback: () => {
                    refreshArbitrationData();
                    toggle();
                },
                componentName: 'Dosya kapatma'
            });

        } catch (error) {
            console.error('FileCloseModal: Submit error:', error);
            toast.error('Dosya kapatma işlemi sırasında hata oluştu. Lütfen tekrar deneyin.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                Dosya Kapatma
            </ModalHeader>
            <ModalBody>
                <Alert color="warning" className="mb-4">
                    <i className="fa fa-warning me-2"></i>
                    Bu işlem tahkim dosyasını kapatacaktır. Lütfen gerekli bilgileri doldurun.
                </Alert>

                <form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="12">
                            <FormGroup className="mb-3">
                                <Label className="text-nowrap mb-2">Tekrar Başvuru Yapılacak Mı?</Label>
                                <div className="d-flex mt-2">
                                    <Button
                                        type="button"
                                        color={formData.willReapply === 'true' ? 'success' : 'outline-success'}
                                        className="me-3"
                                        onClick={() => {
                                            console.log('EVET button clicked');
                                            handleRadioChange('true');
                                        }}
                                    >
                                        Evet {formData.willReapply === 'true' && '✓'}
                                    </Button>
                                    <Button
                                        type="button"
                                        color={formData.willReapply === 'false' ? 'danger' : 'outline-danger'}
                                        onClick={() => {
                                            console.log('HAYIR button clicked');
                                            handleRadioChange('false');
                                        }}
                                    >
                                        Hayır {formData.willReapply === 'false' && '✓'}
                                    </Button>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            <FormGroup className="mb-4">
                                <Label for="fileCloseDescription">Dosya Kapatma Yorumu <span className="text-danger">*</span></Label>
                                <Input
                                    type="select"
                                    name="fileCloseDescription"
                                    id="fileCloseDescription"
                                    value={formData.fileCloseDescription}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Dosya kapatma yorumu seçin...</option>
                                    <option value="Gelen ödeme yeterli">Gelen ödeme yeterli</option>
                                    <option value="Aynı yerden eski hasarlı">Aynı yerden eski hasarlı</option>
                                    <option value="Ağır hasarlı">Ağır hasarlı</option>
                                    <option value="Farklı vekil ödeme almış">Farklı vekil ödeme almış</option>
                                    <option value="Farklı vekil tahkime başvuru yapmış">Farklı vekil tahkime başvuru yapmış</option>
                                    <option value="Vekalet süresi bitti">Vekalet süresi bitti</option>
                                    <option value="Azil">Azil</option>
                                    <option value="Teminat limiti dolu">Teminat limiti dolu</option>
                                    <option value="Sulh">Sulh</option>
                                    <option value="Geri çekme">Geri çekme</option>
                                    <option value="Feragat">Feragat</option>
                                    <option value="Bilirkişi ücreti yatırılmadı">Bilirkişi ücreti yatırılmadı</option>
                                    <option value="Kusur değişmedi">Kusur değişmedi</option>
                                    <option value="Bakiye limit çıkmadı">Bakiye limit çıkmadı</option>
                                    <option value="Görevsizlik">Görevsizlik</option>
                                    <option value="Kısmi dava açıldığından">Kısmi dava açıldığından</option>
                                    <option value="Fatura olmadığından">Fatura olmadığından</option>
                                    <option value="Derdestlik">Derdestlik</option>
                                    <option value="Zaman aşımı">Zaman aşımı</option>
                                    <option value="Yanlış başvuru">Yanlış başvuru</option>
                                    <option value="Diğer">Diğer</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>

                    {/* Diğer seçildiğinde gösterilecek manuel yorum alanı */}
                    {formData.fileCloseDescription === 'Diğer' && (
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-4">
                                    <Label for="fileCloseDescriptionOther">Manuel Dosya Kapatma Yorumu <span className="text-danger">*</span></Label>
                                    <Input
                                        type="textarea"
                                        name="fileCloseDescriptionOther"
                                        id="fileCloseDescriptionOther"
                                        value={formData.fileCloseDescriptionOther}
                                        onChange={handleInputChange}
                                        placeholder="Manuel dosya kapatma yorumunuzu buraya yazın..."
                                        rows="3"
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    )}

                    <Row>
                        <Col md="12">
                            <FormGroup className="mb-4">
                                <Label for="fileCloseComment">Ek Yorum <span className="text-danger">*</span></Label>
                                <Input
                                    type="textarea"
                                    name="fileCloseComment"
                                    id="fileCloseComment"
                                    value={formData.fileCloseComment}
                                    onChange={handleInputChange}
                                    placeholder="Dosya kapatma ile ilgili ek yorumlarınızı buraya yazın..."
                                    rows="3"
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </form>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={isSubmitting}>
                    İptal
                </Button>
                <Button
                    color="danger"
                    onClick={handleSubmit}
                    disabled={
                        isSubmitting || 
                        !formData.fileCloseDescription.trim() || 
                        !formData.fileCloseComment.trim() ||
                        (formData.fileCloseDescription === 'Diğer' && !formData.fileCloseDescriptionOther.trim())
                    }
                >
                    {isSubmitting ? 'Dosya Kapatılıyor...' : 'Dosyayı Kapat'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default FileCloseModal;
